import { useNavigate } from 'react-router-dom'
import {
  bombTimerLegalLocales,
  getBombTimerLegalPath,
  getBombTimerLegalTranslation,
  type BombTimerLegalDocument,
  type BombTimerLegalLocale,
} from '../lib/bombTimerLegal'

type BombTimerLegalLanguageSelectorProps = {
  document: BombTimerLegalDocument
  locale: BombTimerLegalLocale
}

export default function BombTimerLegalLanguageSelector({
  document,
  locale,
}: BombTimerLegalLanguageSelectorProps) {
  const navigate = useNavigate()
  const languageLabel = getBombTimerLegalTranslation(locale, 'Language')

  return (
    <label className="legal-language-selector">
      <span>{languageLabel}</span>
      <select
        aria-label={languageLabel}
        value={locale}
        onChange={(event) => {
          navigate(getBombTimerLegalPath(document, event.target.value as BombTimerLegalLocale))
        }}
      >
        {bombTimerLegalLocales.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  )
}
